import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { IAnagraficaApparato } from "@common/interfaces/anagraficaApparato";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore } from "@datorama/akita";

export interface AnagraficaApparatoState extends EntityState<IAnagraficaApparato, string> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.ANAGRAFICA_APPARATO , realtimeEntity: 'AnagraficaApparato'})
export class AnagraficaApparatoStore extends EntityStore<AnagraficaApparatoState> {
  constructor() {
    super([]);
  }
}
